var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2069 9.75011L3.22731 16.6048C2.0654 17.2688 0.701213 16.1225 1.15769 14.8646L3.45814 8.50008L1.15769 2.13551C0.701213 0.874985 2.0654 -0.26873 3.22731 0.395199L15.2069 7.24992C16.1768 7.80235 16.1743 9.19768 15.2069 9.75011Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqarrow);
export default __webpack_public_path__ + "static/media/faqarrow.d9fd3fe04187933f359e3a61eb2c8197.svg";
export { ForwardRef as ReactComponent };